import { validateTidalLicense } from '@workwave-tidal/license-utils'

export {
  Docs,
  DocsDescription,
  DocsExample,
  Container,
  type ContainerProps,
} from './components/Documentation.js'
export { Meta, type MetaProps } from './components/Meta.js'
export { Story, type StoryProps } from './components/Story.js'
export {
  TidalStoriesProvider,
  useTidalStories,
  useTidalStoriesApi,
  useUpdateGlobalConfigOnce,
  type GlobalControlConfig,
  type GlobalControlsConfig,
  type TidalStories,
  type TidalStoriesApi,
  type NavigationPosition,
  type LazyResolver,
} from './components/TidalStoriesProvider.js'

export * from './components/GlobalControlsProvider.js'
export * from './components/Toolbar/index.js'

// #license-validation
validateTidalLicense()
